import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { ThemeProvider, createTheme, StyledEngineProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import { createStore, compose, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import authReducer from "./store/reducers/auth";
import dashboardReducer from "./store/reducers/dashboard";
import profileReducer from "./store/reducers/profile";
import imageUploadReducer from "./store/reducers/imageUpload";
import ordersReducer from "./store/reducers/orders";
import inventoryReducer from "./store/reducers/inventory";
import searchReducer from "./store/reducers/search";
import addItemReducer from "./store/reducers/addItem";
import reportReducer from "./store/reducers/report";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  profile: profileReducer,
  imageUpload: imageUploadReducer,
  orders: ordersReducer,
  inventory: inventoryReducer,
  search: searchReducer,
  addItem: addItemReducer,
  report: reportReducer
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const theme = createTheme({
  // Remove useNextVariants as it's no longer needed in MUI v6
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  </Provider>
);
